import {
    safeStorageGet,
    safeStorageRemove,
    safeStorageSet,
    SESSION_STORAGE,
} from './safe-storage.js';

const RECOVERY_KEY_PREFIX = 'alpine-chunk-recovery:';
const RECOVERY_QUERY_PARAM = '_chunk_reload';
const RECOVERY_NAVIGATION_WATCHDOG_MS = 4000;
export const CHUNK_RECOVERY_EXHAUSTED = 'exhausted';
export const CHUNK_RECOVERY_SCHEDULED = 'scheduled';
export const CHUNK_RECOVERY_UNAVAILABLE = 'unavailable';
let navigationScheduled = false;

function recoveryKey() {
    return RECOVERY_KEY_PREFIX + window.location.pathname;
}

function removeRecoveryQueryParam() {
    const url = new URL(window.location.href);
    if (!url.searchParams.has(RECOVERY_QUERY_PARAM)) return;

    url.searchParams.delete(RECOVERY_QUERY_PARAM);
    try {
        window.history.replaceState(
            window.history.state,
            '',
            url.pathname + url.search + url.hash,
        );
    } catch {
        // The cache-busting parameter is harmless if history is unavailable.
    }
}

/**
 * Refresh once per route after a component chunk exhausts its network retry.
 * The session marker must land before navigation, otherwise a restricted
 * webview could reload the same stale runtime forever.
 */
export function recoverRetriedChunkLoad() {
    if (navigationScheduled) return CHUNK_RECOVERY_SCHEDULED;

    const key = recoveryKey();
    if (safeStorageGet(key, SESSION_STORAGE) === '1') {
        removeRecoveryQueryParam();
        return CHUNK_RECOVERY_EXHAUSTED;
    }

    if (!safeStorageSet(key, '1', SESSION_STORAGE)) {
        return CHUNK_RECOVERY_UNAVAILABLE;
    }

    const url = new URL(window.location.href);
    url.searchParams.set(RECOVERY_QUERY_PARAM, Date.now().toString(36));
    navigationScheduled = true;

    try {
        window.location.replace(url.toString());
        return CHUNK_RECOVERY_SCHEDULED;
    } catch {
        navigationScheduled = false;
        safeStorageRemove(key, SESSION_STORAGE);
        return CHUNK_RECOVERY_UNAVAILABLE;
    }
}

export function isChunkRecoveryNavigationScheduled() {
    return navigationScheduled;
}

/** Reject if the current document survives a navigation request. */
export function waitForChunkRecoveryNavigation(error) {
    return new Promise((resolve, reject) => {
        window.setTimeout(() => {
            try {
                window.stop();
            } catch {
                // The fallback still isolates the failed roots if the host denies stop().
            }
            navigationScheduled = false;
            reject(error);
        }, RECOVERY_NAVIGATION_WATCHDOG_MS);
    });
}

/** Clear the route marker only after every lazy component loaded successfully. */
export function finishChunkLoadRecovery() {
    if (navigationScheduled) return;

    safeStorageRemove(recoveryKey(), SESSION_STORAGE);
    removeRecoveryQueryParam();
}
